module.exports = __webpack_public_path__ + "static/media/collect.1ad72af3.svg";